import portApi from "@/api/port";
const product = {
  state: {
    portList: [],
  },
  getters: {
    portList(state) {
      return state.portList.map((port) => {
        return {
          label: port.name,
          value: port.portNid,
        };
      });
    },
  },
  mutations: {
    setPortList(state, data) {
      state.portList = data;
    },
  },
  actions: {
    portList({ commit }, data) {
      return portApi.getPortList(data).then((res) => {
        commit("setPortList", res.value);
      });
    },
  },
};

export default product;
